import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getDigestTimes,
  resolveAccessToken,
  updateDigestTimes,
  type UpdateDigestTimesInput,
} from '@nomiss/services';

export const digestTimeQueryKeys = {
  me: ['account', 'digest-times'] as const,
};

export function useDigestTimes(accessToken?: string | null, enabled = true) {
  const token = accessToken ?? resolveAccessToken();

  return useQuery({
    queryKey: [...digestTimeQueryKeys.me, token ?? ''] as const,
    queryFn: () => getDigestTimes(),
    enabled: enabled && Boolean(token),
  });
}

export function useUpdateDigestTimes() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateDigestTimesInput) => updateDigestTimes(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: digestTimeQueryKeys.me });
    },
  });
}
